import { useV2UI } from '@vrplatform/theme';
import { useContext, useMemo } from 'react';
import { type Feature, getEnabledFeatures } from '../utils';
import { teamContext } from './team/team.context';

export function useEnabledFeatures() {
  const { features } = useContext(teamContext);
  const { isV2 } = useV2UI();

  return useMemo<Record<Feature, boolean>>(
    () =>
      getEnabledFeatures({
        isV2,
        featureIds: features,
      }),
    [features, isV2]
  );
}

export function useHasEnabledFeatures() {
  const { features, isPartnerAdmin, isSuperAdmin } = useContext(teamContext);

  return useMemo<boolean>(() => {
    if (isSuperAdmin || isPartnerAdmin) return true;

    return features.length > 0;
  }, [features, isSuperAdmin, isPartnerAdmin]);
}
